import * as React from "react";
import {Box, Button, Stack, Typography} from "@mui/material";
import {useSurroundings} from "./hooks/useSurroundings";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {usePoliceMode} from "../policeMode/hook/usePoliceMode";
import {truncateStr} from "../Service";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

const SwitchBox = ({mail,name, canSwitch}) => {
    const {switchAccount} = useSurroundings();
    const {mode} = useDarkMode();
    const {police} = usePoliceMode();
    return (
        <Box className={'profile-associate'} sx={{backgroundColor:mode.settings.inputBackgroundColor}}>
            <Stack marginLeft={'8px'} direction={'row'} justifyContent={"space-between"} alignItems={"center"}>
                <Typography variant={'body2'} color={mode.settings.textColor3}>{name}</Typography>
                {canSwitch && <Button className="btn-white" onClick={() => switchAccount(mail)} sx={{backgroundColor:mode.settings.card2BackgroundColor}}>
                    <img src={'/assets/icon/swap-vertical.png'} alt={'Changer de compte'} style={{marginRight:'10px'}}/>
                    <Typography variant={"subtitle1"} component="span" color={mode.settings.breadcrumbColor1}>Basculer vers</Typography>
                </Button>}
            </Stack>

            <Stack direction={'row'} marginLeft={'8px'} marginTop={'20px'} flexWrap={'nowrap'}>
                <MailOutlineIcon sx={{marginRight : '5px', color: mode.settings.textColor3}}/>
                <Typography color={mode.settings.textColor3}>Email</Typography>
                <Typography variant={'body2'} color={mode.settings.textColor3} marginLeft={'10px'}>
                    {police.normalMode ? truncateStr(mail,25) : truncateStr(mail,20)}
                </Typography>
            </Stack>
        </Box>
    )
}

export default SwitchBox;
